<svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [class]="class">
  <path
    d="M13.0892 10.6561V13.65C13.0892 14.2921 12.8341 14.9079 12.3801 15.3619C11.9261 15.816 11.3103 16.071 10.6682 16.071H6.46373C6.25087 16.0741 6.04783 16.1611 5.89883 16.3131L3.60695 18.605C3.55055 18.6603 3.47917 18.6978 3.40164 18.7129C3.32412 18.7281 3.24386 18.7201 3.17083 18.69C3.0978 18.6599 3.03519 18.6091 2.99078 18.5438C2.94637 18.4784 2.92211 18.4015 2.921 18.3226V16.765C2.92481 16.5763 2.86229 16.3921 2.74433 16.2446C2.62636 16.0972 2.46043 15.9958 2.2754 15.958C1.76519 15.8169 1.3153 15.5124 0.994648 15.0911C0.673993 14.6699 0.500241 14.1552 0.5 13.6258V8.921C0.5 8.27891 0.755069 7.66312 1.20909 7.2091C1.66312 6.75507 2.27891 6.5 2.921 6.5H9.05421"
    class="sparkle-msg"
    stroke="black"
    stroke-miterlimit="10"
    stroke-linecap="round" />
  <path
    d="M4.375 11.2207V11.2286"
    class="sparkle-msg"
    stroke="black"
    stroke-width="1.60713"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M6.79297 11.2207V11.2286"
    class="sparkle-msg"
    stroke="black"
    stroke-width="1.60713"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M9.21875 11.2207V11.2286"
    class="sparkle-msg"
    stroke="black"
    stroke-width="1.60713"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    class="sparkle-star"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.1722 1.24361C16.0334 1.24361 15.9114 1.33563 15.8733 1.4691L15.5362 2.64896C15.3886 3.16538 14.985 3.56905 14.4685 3.7166L13.2887 4.0537C13.1552 4.09184 13.0632 4.21383 13.0632 4.35265C13.0632 4.49146 13.1552 4.61345 13.2887 4.65159L14.4685 4.98869C14.985 5.13624 15.3886 5.53991 15.5362 6.05633L15.8733 7.23619C15.9114 7.36966 16.0334 7.46168 16.1722 7.46168C16.311 7.46168 16.433 7.36966 16.4712 7.23619L16.8083 6.05633C16.9558 5.53991 17.3595 5.13624 17.8759 4.98869L19.0558 4.65159C19.1892 4.61345 19.2812 4.49146 19.2812 4.35265C19.2812 4.21383 19.1892 4.09184 19.0558 4.0537L17.8759 3.7166C17.3595 3.56905 16.9558 3.16538 16.8083 2.64896L16.4712 1.4691C16.433 1.33563 16.311 1.24361 16.1722 1.24361Z"
    fill="orange" />
  <path
    class="sparkle-star"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.4414 0C12.2987 0 12.1744 0.0970943 12.1398 0.235498L12.0324 0.664736C11.935 1.05461 11.6306 1.35902 11.2407 1.45649L10.8115 1.5638C10.6731 1.5984 10.576 1.72276 10.576 1.86542C10.576 2.00808 10.6731 2.13244 10.8115 2.16704L11.2407 2.27435C11.6306 2.37182 11.935 2.67623 12.0324 3.0661L12.1398 3.49534C12.1744 3.63374 12.2987 3.73084 12.4414 3.73084C12.584 3.73084 12.7084 3.63374 12.743 3.49534L12.8503 3.0661C12.9478 2.67623 13.2522 2.37182 13.6421 2.27435L14.0713 2.16704C14.2097 2.13244 14.3068 2.00808 14.3068 1.86542C14.3068 1.72276 14.2097 1.5984 14.0713 1.5638L13.6421 1.45649C13.2522 1.35902 12.9478 1.05461 12.8503 0.664736L12.743 0.235498C12.7084 0.0970943 12.584 0 12.4414 0Z"
    fill="orange" />
  <path
    class="sparkle-star"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.0632 5.59626C12.9294 5.59626 12.8106 5.68189 12.7682 5.80885L12.6048 6.29913C12.5429 6.48481 12.3972 6.63051 12.2115 6.6924L11.7213 6.85583C11.5943 6.89814 11.5087 7.01695 11.5087 7.15077C11.5087 7.2846 11.5943 7.40341 11.7213 7.44572L12.2115 7.60915C12.3972 7.67104 12.5429 7.81674 12.6048 8.00242L12.7682 8.4927C12.8106 8.61966 12.9294 8.70529 13.0632 8.70529C13.197 8.70529 13.3158 8.61966 13.3581 8.4927L13.5216 8.00242C13.5835 7.81674 13.7292 7.67104 13.9148 7.60915L14.4051 7.44572C14.5321 7.40341 14.6177 7.2846 14.6177 7.15077C14.6177 7.01695 14.5321 6.89814 14.4051 6.85583L13.9148 6.6924C13.7292 6.63051 13.5835 6.48481 13.5216 6.29913L13.3581 5.80885C13.3158 5.68189 13.197 5.59626 13.0632 5.59626Z"
    fill="orange" />
</svg>
